import { useMemo } from 'react';
import JSON_DATA_HEADER from '../data/header.json';

export const useHeaderUsuarioLogs = () => {
    return useMemo(() => JSON_DATA_HEADER, []);
};
